import React from 'react';
import './theme.css';

class LoadingBar extends React.Component {
  /*constructor(props)
  {
    super(props);
    this.state = {cnt: 0};
  }

  componentDidMount() {//elinditjuk a timert amikor hozzaadjuk a domhoz
    this.timerID = setInterval(
          () => this.tick(),
          100//100ms
        );
  }
  componentWillUnmount() {
    clearInterval(this.timerID);//megallitjuk a timert amikor az ora lekerul a domrol
  }
  tick() {
    this.setState((prevState) => {return {cnt: (prevState.cnt + 1)%5}});
  }*/

  render(){
    /*let dots = "";
    for(let i=0;i<5;i++)
    {
      if(this.state.cnt == i)
        dots+=' ';
      else
        dots+='_';
    }*/
    return (
        <div className="loader"/>
    );
  }
}

export default LoadingBar;



// WEBPACK FOOTER //
// ./src/Component/LoadingBar.js